// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-container[data-v-70a57896] {\n  margin: 40px 57px 50px 32px;\n}\n.page-title[data-v-70a57896] {\n  padding-bottom: 24px;\n  border-bottom: 1px solid #D3D7DF;\n}\n.detail-content[data-v-70a57896] {\n  margin-top: 32px;\n}\n.page-footer[data-v-70a57896] {\n  margin-top: 24px;\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
